import { render } from "./DashboardOptions.vue?vue&type=template&id=07324c0a"
import script from "./DashboardOptions.vue?vue&type=script&lang=js"
export * from "./DashboardOptions.vue?vue&type=script&lang=js"
script.render = render

export default script